export default {"src":"/_next/static/image/public/images/ic_image_upload.d36930ca03ef1781bc78bbb34405909c.svg","height":32,"width":33};